/** Is excution in browser context */
export const isInBrowser = () => typeof window !== 'undefined'
